module.exports = __webpack_public_path__ + "static/media/fav.abb386e3.svg";